import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type UpsertSectionTemplateRequest as SchemaUpsertSectionTemplateRequest } from '../schemas/UpsertSectionTemplateRequest';
import { type UpsertSectionTemplateResponse as SchemaUpsertSectionTemplateResponse } from '../schemas/UpsertSectionTemplateResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SectionTemplate
 */
export const UpdateSectionTemplateContentType = 'application/json' as const;
export type UpdateSectionTemplateRequest = SchemaUpsertSectionTemplateRequest;
export type UpdateSectionTemplateResponses = LinkCommonErrorResponses & {
    /**
     * @description Section template updated successfully
     */
    '200': {
        'application/json': SchemaUpsertSectionTemplateResponse;
    };
};
export type UpdateSectionTemplateResponseSuccess = UpdateSectionTemplateResponses['200']['application/json'];
export type UpdateSectionTemplateSearchParams = undefined;
export type UpdateSectionTemplatePathParameters = {
    id: string;
};
export const UpdateSectionTemplateUrl = '/section_template/{id}' as const;
export const UpdateSectionTemplateMethod = 'PUT' as const;
export const getUpdateSectionTemplateUrl = (params: UpdateSectionTemplatePathParameters) =>
    UpdateSectionTemplateUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateSectionTemplatePathParameters) =>
        String(params[param])
    );
